import React, { useState, useEffect} from "react";
import axios from "axios";
export default function FrontNewList() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  let baseURL = "https://fukuyamarccenter.com/item_view_for_json/";
  useEffect(() => {
    axios.post(
      baseURL,
      {
        action: "new_item",
      },
      {
        headers: {
        'Content-Type': 'application/json',
        },
      }
      ).then((response) => {
        setData(response.data);
      }).catch((error) => {
        setError(error);
    });
    }, [baseURL]);
  function url_create(e){
    const currentUrl = window.location.href;
    return new URL(e, currentUrl).href;
  }
  if (!data) {
    return (
      <adide>Loading...</adide>
    );
  }

  return (
    <section>
      <a href={url_create("new_items")}><h2 className="top_title_h2">新商品・新規登録商品</h2></a>
      <div className="product_box max_width">
        {data.map((item) => (
        <section className="product_box_child" key={item.id}>
          <div className="product_stock">
            <div className="product_stock_img"><a href={item.url} dangerouslySetInnerHTML={{ __html: item.img }} /></div>
            <div className="product_stock_title"><a href={item.url}><h2 dangerouslySetInnerHTML={{ __html: item.name }}></h2></a></div>
            <div className="product_stock_price" dangerouslySetInnerHTML={{ __html: item.price }} ></div>
            <div className="product_stock_icon" dangerouslySetInnerHTML={{ __html: item.stock_icon }} ></div>
          </div>
        </section>
        ))}
      </div>
      <div class="blog_item_link next_items"><a href="https://fukuyamarccenter.com/new_items">新製品・発売予定</a></div>
    </section>
  );
}
